var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportProblem = function SvgReportProblem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.558 35.002h30.883c1.284 0 2.084-1.383 1.45-2.5L21.442 5.835c-.65-1.116-2.25-1.116-2.883 0L3.108 32.502c-.633 1.117.167 2.5 1.45 2.5m17.117-5H18.34V26.67h3.334zm-1.667-6.667c-.916 0-1.666-.75-1.666-1.666v-3.334c0-.916.75-1.666 1.666-1.666.917 0 1.667.75 1.667 1.666v3.334c0 .916-.75 1.666-1.667 1.666"
  })));
};
export default SvgReportProblem;